import React, { forwardRef } from 'react'
import { SnackbarContentProps, useSnackbar } from 'notistack'
import tw from 'twin.macro'
import {
  CircleTickMajor,
  CircleCancelMajor,
  CircleAlertMajor,
  MobileCancelMajor,
} from '@shopify/polaris-icons'
import { IconButton } from '@mui/material'
import { colors } from 'src/theme'

export interface CustomSnackbarContentProps extends SnackbarContentProps {
  message: React.ReactNode
  variant?: 'success' | 'error' | 'warning'
}

const variantConfig = {
  success: { icon: CircleTickMajor, color: colors.COLORS_GREEN_500 },
  error: { icon: CircleCancelMajor, color: colors.COLORS_RED_500 },
  warning: { icon: CircleAlertMajor, color: colors.COLORS_RED_500 },
}

export const CustomSnackbarContent = forwardRef<HTMLDivElement, CustomSnackbarContentProps>(
  ({ message, variant, id, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar()
    const config = variant && variantConfig[variant]
    const Icon = config?.icon

    const handleClose = () => {
      if (id) {
        closeSnackbar(id)
      }
    }

    return (
      <div
        ref={ref}
        {...props}
        css={tw`bg-black px-4 py-2 rounded-lg flex items-center justify-between text-base text-white`}
      >
        <div css={tw`flex items-center`}>
          {Icon && <Icon width={20} height={20} fill={config.color} css={tw`flex-shrink-0 mr-4`} />}
          <div>{message}</div>
        </div>
        <IconButton onClick={handleClose} size="small" sx={{ ml: 2 }}>
          <MobileCancelMajor width={20} height={20} fill={colors.BASICS_WHITE} />
        </IconButton>
      </div>
    )
  },
)
